import React from 'react'

export const READY = "적용"
export const CAN_SUBMIT = "변경사항 적용"
export const DOING = <span className="ico_blog ico_doing">저장중</span>
export const DONE = [
	'저장 완료',
	<span key="1" className="ico_blog ico_over" />
]
